import { useTranslation } from 'react-i18next'

import { RadioGroupOption } from 'components/Form'
import {
  UnfilledRecoveryPrebidBehaviour,
  unfilledRecoveryPrebidBehaviours,
} from 'features/inventory/types/unfilledRecoveryPrebidBehaviour'

export const usePrebidBehavioursRadioGroup = (): RadioGroupOption[] => {
  const { t } = useTranslation('features/domain', {
    keyPrefix: 'form.unfilledRecovery.prebidSettings.prebidBehaviourType.values',
  })

  return unfilledRecoveryPrebidBehaviours.map(
    (prebidBehaviour: UnfilledRecoveryPrebidBehaviour): RadioGroupOption => ({
      label: t(`${prebidBehaviour}.content`),
      ...(prebidBehaviour === 'disabled'
        ? {}
        : {
            tooltip: {
              content: t(`${prebidBehaviour}.tooltip.content`),
            },
          }),
      value: prebidBehaviour,
    }),
  )
}
